import { auth, db } from './config';
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { notifyError } from '../utils/alerts';

const provider = new GoogleAuthProvider();

export const loginWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;

        // Consultar si el correo está en la lista blanca
        const userDoc = await getDoc(doc(db, "usuarios_autorizados", user.email));

        if (!userDoc.exists()) {
            await signOut(auth);
            notifyError(
                "Acceso Denegado", 
                "Lo sentimos, este correo no tiene permisos de administrador."
            );
            return null;
        }

        return user;
    } catch (error) {
        if (error.code !== 'auth/cancelled-popup-request') {
            notifyError("Error de Conexión", "Hubo un problema al intentar conectar con Google.");
        }
    }
};

export const logoutFirebase = () => signOut(auth);